import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Wrapper standard sulle maschere di inserimento/modifica (piano ui-fixes, F0) — header
 * (titolo), corpo (`<ng-content>`) e footer (Annulla/Salva) uniformi, così le maschere
 * scritte a mano non ripetono più footer/bottoni ognuna a modo suo. Supporta `[(visible)]`
 * come un normale `p-dialog`.
 */
@Component({
  selector: 'emed-form-dialog',
  standalone: false,
  templateUrl: './emed-form-dialog.component.html'
})
export class EmedFormDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() title = '';
  @Input() width = '45rem';
  @Input() saveLabel = 'Salva';
  @Input() saveDisabled = false;
  /** false quando il contenuto proiettato (es. emed-base-form) porta già il proprio footer salva/annulla. */
  @Input() showFooter = true;

  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  public onVisibleChange(value: boolean): void {
    this.visible = value;
    this.visibleChange.emit(value);
  }

  /** Chiusura via X/escape/click fuori dialog: equivale ad annullare la maschera. */
  public onHide(): void {
    this.cancel.emit();
  }
}
